import { render, staticRenderFns } from "./FBChart.vue?vue&type=template&id=62501958&scoped=true&"
import script from "./FBChart.vue?vue&type=script&lang=js&"
export * from "./FBChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62501958",
  null
  
)

export default component.exports